import React from 'react';
import { useSelector } from 'react-redux';

import { getScreenSectionsKeysArray } from 'app/store/data/formsConfig';
import { RootState } from 'app/store/rootReducer';
import { FormSection } from 'app/components/FormSection';
import { FormScreenProps } from './FormScreen.interfaces';

const FormScreen = (props: FormScreenProps) => {
  const {
    SectionProps,
    label,
    controlsList,
    renderValidationMessage,
    renderFormRowContainer,
    renderSectionHeading,
    renderSection: Section = FormSection,
    isLoadingResult,
    formName,
    screenKey,
  } = props;

  const sectionsKeys = useSelector((state: RootState) =>
    getScreenSectionsKeysArray(state, formName, screenKey)
  );

  return (
    <>
      {sectionsKeys.map((sectionKey) => (
        <Section
          {...SectionProps}
          sectionKey={sectionKey}
          screenLabel={label}
          key={sectionKey}
          formName={formName}
          controlsList={controlsList}
          renderValidationMessage={renderValidationMessage}
          renderFormRowContainer={renderFormRowContainer}
          renderSectionHeading={renderSectionHeading}
          isLoadingResult={isLoadingResult}
        />
      ))}
    </>
  );
};

export default FormScreen;
